import { Pipe, PipeTransform } from '@angular/core';

import { Team } from '../data/models/collections/team';

@Pipe({
  name: 'displayTeamMember',
})
export class DisplayTeamMemberPipe implements PipeTransform {
  transform(team: Team): string {
    return team?.consent?.nameDisplay ? `${team.firstName} ${team.lastName}` : '';
  }
}
